import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-28961924"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["id", "aria-labelledby"]
const _hoisted_2 = { class: "modal-dialog modal-lg" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-body" }
const _hoisted_5 = { class: "d-flex flex-row" }
const _hoisted_6 = { class: "fs-8 date-text flex-grow-1" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  class: "btn-close",
  "data-bs-dismiss": "modal",
  "aria-label": "Close"
}, null, -1))
const _hoisted_8 = { class: "fw-bold mt-3 mb-4 pb-4 border-bottom" }
const _hoisted_9 = { class: "d-flex flex-column border-bottom" }
const _hoisted_10 = {
  key: 0,
  class: "d-flex flex-wrap m-20"
}
const _hoisted_11 = { class: "d-flex justify-content-sm-end mb-4" }
const _hoisted_12 = { class: "user-comment-wrap mt-4" }
const _hoisted_13 = { class: "user-comment-wrap" }
const _hoisted_14 = { class: "d-flex justify-content-center mt-3" }

import { computed, ComputedRef, PropType, ref } from 'vue'
import { ARTICLE_MODAL_ID } from '@/views/community-admin/community-site/constants'
import { translate } from '@/languages/i18n'
import { GetPostType } from '@/store/modules/user-post-management/user-post.getters'
import LikeButton from '@/components/like-button/LikeAdmin.vue'
import HashTag from '@/components/hash-tag/index.vue'
import Comment from '@/views/shared/communities/components/Comment.vue'
import Button from '@/components/button/index.vue'
import { COMMUNITY_SITE_ADMIN_STORE, POST_STORE } from '@/store/constants'
import { useStore } from 'vuex'
import { ChangeTime } from '@/constants/datepicker'
import ArticleCommentContainer from '@/views/community-admin/community-site/components/ArticleCommentContainer.vue'
import { useRoute, useRouter } from 'vue-router'
import { onMounted } from 'vue-demi'
import { onUnmounted } from '@vue/runtime-core'
import { CommentType } from '@/store/modules-community-admin/community-site'
import EditorPreview from '@/views/community-admin/community-site/components/EditorPreview.vue'


export default /*#__PURE__*/_defineComponent({
  props: {
  modalId: {
    type: Object as PropType<string>,
    default: ARTICLE_MODAL_ID,
  },
},
  emits: ['showDeleteCommentModal', 'showUpdateCommentErrorModal', 'showCommentUserDetailInformation'],
  setup(__props, { expose, emit }) {

const props = __props

const store = useStore()
const route = useRoute()
const router = useRouter()
const listUserMention = computed(() => store.getters[POST_STORE.GETTERS.LIST_USER_MENTION_POST])
const mentionUsers = computed(() => {
  if (listUserMention?.value?.data) {
    return listUserMention?.value.data.filter((item: any) => item.id !== listUserMention?.value.current_user_id)
  }

  return []
})


const articleCommentController = ref()
// State of collapse/expand representing comment list - update ONLY after a comment is interacted
// true: expanded

const commentCollapseState = ref<boolean>(true)
// Use to control reset state of comment input box
// prevent cased of input still kept old value when its container visible state changed
const resetFlag = ref<boolean>(false)

const post = computed<ComputedRef<GetPostType>>(() => store.getters[COMMUNITY_SITE_ADMIN_STORE.GETTERS.ARTICLE_DETAIL])
const commentList = computed<ComputedRef<GetPostType>>(() => store.getters[COMMUNITY_SITE_ADMIN_STORE.GETTERS.COMMENTS] ?? { total: 0, comments: [] })


onMounted(() => {
  document.getElementById(props?.modalId).addEventListener('hidden.bs.modal', handleCommentCollapseState)
})

onUnmounted(() => {
  document.getElementById(props?.modalId).removeEventListener('hidden.bs.modal', handleCommentCollapseState)
})

const reset = ref<number>(0)
const resetComment = () => {
  reset.value++
}
onMounted(() => {
  window.addEventListener('hidden.bs.modal', function () {
    resetComment()
    if (route.query.target_content_id) {
      const { target_content_id, ...remainingQueries } = route.query

      router.replace({
        path: route.path,
        query: remainingQueries,
      })
    }
  })
})

const handleFetchAllComment = () => {
  const payload = {
    community_id: route?.params?.id,
    params: {
      post_id: post.value?.id ?? route.query?.post_id,
      create_by_admin: true,
    },
  }
  store.dispatch(COMMUNITY_SITE_ADMIN_STORE.ACTIONS.GET_COMMENT_LIST, payload)
}

const handleCommentCollapseState = () => {
  if (articleCommentController.value) {
    articleCommentController.value?.updateCommentListCollapseState(false)
  }
}

const showDeleteCommentModal = (comment: CommentType, commentListState: boolean) => {
  commentCollapseState.value = commentListState
  emit('showDeleteCommentModal', comment)
}

const updateCommentPublishedState = (comment: CommentType) => {
  emit('updateCommentPublishedState', comment)
  handleFetchAllComment()
}

const showCommentUserDetailInformation = (comment) => {
  emit('showCommentUserDetailInformation', comment)
}

const reloadCommentList: boolean = () => {
  if (!commentCollapseState.value) return false
  handleFetchAllComment()
  return true
}

const resetCommentInput = () => {
  resetFlag.value = !resetFlag.value
}

expose({
  reloadCommentList,
  resetCommentInput,
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "modal fade",
    id: __props.modalId,
    tabindex: "-1",
    "aria-labelledby": __props.modalId,
    "aria-hidden": "true",
    onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.buttonClick && _ctx.buttonClick(...args)), ["self"]))
  }, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("span", _hoisted_6, _toDisplayString(_unref(post)?.published_date ? _unref(ChangeTime)(_unref(post)?.published_date) : '-'), 1),
            _hoisted_7
          ]),
          _createElementVNode("h4", _hoisted_8, _toDisplayString(_unref(post)?.title), 1),
          _createVNode(EditorPreview, {
            content: _unref(post)?.content
          }, null, 8, ["content"]),
          _createElementVNode("div", _hoisted_9, [
            (_unref(post)?.content_type !== 4)
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(post)?.tags, (tag) => {
                    return (_openBlock(), _createBlock(HashTag, {
                      key: tag.id,
                      tag: tag,
                      class: "me-2 mb-2"
                    }, null, 8, ["tag"]))
                  }), 128))
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_11, [
              _createVNode(LikeButton, {
                activeBtn: false,
                class: "me-2",
                count: _unref(post)?.like_count,
                like: _unref(post)?.like,
                id: _unref(post)?.id,
                type: 'like',
                loadingLike: _ctx.loadingLike
              }, null, 8, ["count", "like", "id", "loadingLike"])
            ])
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createVNode(ArticleCommentContainer, {
              ref: (_value, _refs) => {
                _refs['articleCommentController'] = _value
                articleCommentController.value = _value
              },
              comments: _unref(commentList).comments,
              comment_count: _unref(commentList).total,
              postId: _unref(post)?.id,
              modalId: __props.modalId,
              fetchAllComment: handleFetchAllComment,
              onShowDeleteCommentModal: showDeleteCommentModal,
              onUpdateCommentPublishedState: updateCommentPublishedState,
              onShowCommentUserDetailInformation: showCommentUserDetailInformation
            }, null, 8, ["comments", "comment_count", "postId", "modalId"])
          ]),
          _createElementVNode("div", _hoisted_13, [
            _createVNode(Comment, {
              post: _unref(post),
              create_by_admin: true,
              reset: resetFlag.value,
              admin: true,
              users: _unref(mentionUsers),
              titleMention: _unref(translate)('titleMentionCT10')
            }, null, 8, ["post", "reset", "users", "titleMention"])
          ]),
          _createElementVNode("div", _hoisted_14, [
            _createVNode(Button, {
              title: _unref(translate)('close'),
              type: 'secondary',
              "data-bs-dismiss": "modal"
            }, null, 8, ["title"])
          ])
        ])
      ])
    ])
  ], 8, _hoisted_1))
}
}

})